module.exports = __webpack_public_path__ + "media/images/themes/mandy/10-59c1d476c31cadf4348dfbb74f5a5dde.webp";